import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useCurrentuser } from '@uplift/contexts';
import { useL10n } from '@uplift/hooks';
import { UpliftLogo } from '@uplift/icons';
import { Modal, ModalActions, ModalContent, ModalProgressButton } from '@uplift/ui-v2';

import { BackgroundAnimation } from '../components';

export type LiveShowConfettiModalProps = {
  isMobile: boolean;
  handleClick: () => void;
};

export const LiveShowConfettiModal: React.VFC<LiveShowConfettiModalProps> = ({ handleClick }) => {
  const { classes } = useStyles();
  const user = useCurrentuser();
  const l10n = useL10n();

  return (
    <Modal
      open
      fullWidth
      maxWidth="sm"
      showCloseIcon={false}
      classes={{ paperWidthSm: classes.paperWidthSm }}
    >
      <Box zIndex={-1}>
        <BackgroundAnimation />
      </Box>
      <ModalContent>
        <Box className={classes.logo} mb={5}>
          <UpliftLogo />
        </Box>
        <Box className={classes.color} ml="1.5rem" mr="1.5rem">
          <Typography variant="h1" >{`${l10n.providerSettings.onboarding.youAreLive} ${user.firstName}!`}</Typography>
          <Typography variant="body2" >{l10n.providerSettings.onboarding.getStartedMessage}</Typography>
        </Box>
      </ModalContent>
      <ModalActions>
        <ModalProgressButton variant="contained" color="secondary" onClick={handleClick} fullWidth className={classes.buttonMargin}>
          {l10n.providerSettings.onboarding.goToDashboard}
        </ModalProgressButton>
      </ModalActions>
    </Modal>
  );
};

const useStyles = makeStyles()(theme => ({
  logo: {
    display: 'flex',
    justifyContent: 'center',
    '& svg path': {
      fill: theme.palette.darkSlate.main
    }
  },
  color: {
    color: theme.palette.darkSlate.main,
  },
  paperWidthSm: {
    maxWidth: '500px',
  },
  buttonMargin: {
    margin: theme.spacing(-2, 2, 2, 2),
  }
}));
